var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-avatar',_vm._g(_vm._b({},'md-avatar',_vm.$attrs,false),_vm.$listeners),[_c('img',{staticClass:"avatar",attrs:{"src":_vm.imgSrc,"alt":"Avatar"},on:{"error":_vm.handleError}})])}
var staticRenderFns = []

export { render, staticRenderFns }